<template>
  <div class="store-selector" :class="{ 'has-to-select': !(selectedStore) }">
    <div class="informations" v-if="!(selectedStore)">
      <div class="inner">
        <div class="icon"><span class="fi-rr-geolocation"></span></div>
        <div class="text"><p>Choisir un magasin <br/>ou <a href="" class="get-location" @click.prevent="triggerGeolocation">me géolocaliser</a></p></div>
      </div>
    </div>
    <div class="informations" v-else>
      <div class="inner">
        <div class="store-name"><p>{{ selectedStore.name }}</p></div>
        <div class="opening-status">
          <p v-if="selectedStore.openingStatus === 'closed'"><span :class="[selectedStore.openingStatus]">Fermé</span> {{ selectedStore.openingSentence }}</p>
          <p v-else><span :class="[selectedStore.openingStatus]">Ouvert</span> {{ selectedStore.openingSentence }}</p>
        </div>
      </div>
    </div>
    <div class="button">
      <a href="" @click.prevent="openLinkPopup" class="btn btn-primary btn-small" v-if="!(selectedStore)">Choisir un magasin</a>
      <a href="" @click.prevent="openPopup" class="btn btn-primary btn-small" v-else>Changer de magasin</a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Store',
  props: {
    modelValue: [String, Number]
  },
  data () {
    return {
      payload: {
        geolocation: null
      }
    }
  },
  computed: {
    ...mapState({
      selectedCode: state => state.stores.selected,
      stores: state => state.stores.items,
      phone: state => state.phone.item,
      loading: state => state.stores.loading
    }),
    selectedStore () {
      let selectedStore = null

      this.stores.forEach((store) => {
        if(store.code === this.modelValue) {
          selectedStore = store
        }
      })

      return selectedStore
    }
  },
  mounted () {
    this.initGeolocation().then((response) => {
      this.payload.geolocation = response
      this.getStores(this.payload).then(() => {
        this.stores.forEach((store) => {
          if(store.default) this.setStore(store.code)
        })

        this.getStocks({ packID: this.phone.packId })
      })
    })

    document.addEventListener('geolocated', (e) => {
      this.$emit('update:modelValue', e.detail.code)
      this.setStore(e.detail.code)
    })
  },
  methods: {
    ...mapActions('stores', ['getStores', 'getStocks', 'openPopup', 'initGeolocation', 'setStore']),
    triggerGeolocation() {
      const geolocationLink = document.querySelector('header.main-header .head .actions .stores .store-selector .selector-map a.geolocation')
      if (geolocationLink) geolocationLink.click()
    },
    openLinkPopup() {

      this.openPopup()

    }
  },
  watch: {
    selectedCode () {
      this.$emit('update:modelValue', this.selectedCode)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.store-selector{
  display: grid;
  grid-template-columns: 1fr auto;
  grid-column-gap: 20px;

  @include responsive(mobile) {
    grid-template-columns: 1fr;
    grid-row-gap: 10px;
  }

  &.has-to-select{
    .informations{

      @include responsive(mobile){
        display: none;
      }

      .inner{
        display: grid;
        grid-template-columns: auto 1fr;
        grid-column-gap: 20px;

        @include responsive(tablet){
          grid-column-gap: 20px;
          grid-template-columns: auto auto;
          width: auto;
        }

        .icon {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 26px;
          color: $primary;

          @include responsive(tablet){
            color: $white;
          }

          span {
            display: inline-block;
            vertical-align: middle;
            @include transform(translateY(-2px));
          }
        }

        .text {
          p {
            color: $black;
            font-size: px2rem(14px);
            line-height: px2rem(21px);
            margin-bottom: 0;

            @include responsive(tablet){
              color: $white;
            }

            a {
              color: $primary;
              font-weight: $fontBold;

              @include responsive(tablet){
                color: $white;
              }
            }
          }
        }
      }
    }
  }

  .informations{
    display: flex;
    align-items: center;
    justify-content: center;

    .store-name {
      margin-bottom: 5px;

      p {
        font-size: px2rem(16px);
        font-weight: $fontRegular;
        line-height: px2rem(21px);
      }
    }

    .opening-status{
      p{
        font-size: px2rem(13px);
        line-height: px2rem(17px);
        color: $black;
        @include transition();

        span{
          display: inline-block;
          position: relative;

          &.closed{
            color: $red;

            &:before{
              background-color: $red;
            }
          }

          &.opened{
            color: #5CD414;

            &:before{
              background-color: #5CD414;
            }
          }

          &:after{
            display: inline-block;
            content: '-';
            color: darken($white, 45%);
            margin: 0 5px;
            vertical-align: middle;
          }

          &:before{
            display: inline-block;
            content: '';
            width: 9px;
            height: 9px;
            background-color: $red;
            vertical-align: middle;
            margin-right: 5px;
            @include radius(100%);
          }
        }
      }
    }
  }

  .button{
    display: flex;
    align-items: center;
    justify-content: center;

    @include responsive(mobile) {
      a{
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
